
/**
 * @roxi/routify 2.18.18
 * File generated Thu May 22 2025 09:53:26 GMT-0700 (Pacific Daylight Time)
 */

export const __version = "2.18.18"
export const __timestamp = "2025-05-22T16:53:26.982Z"

//buildRoutes
import { buildClientTree } from "@roxi/routify/runtime/buildRoutes.js"

//imports
import _changePassword from '../src/pages/change-password.svelte'
import _dashboard from '../src/pages/dashboard.svelte'
import _ecprSearch from '../src/pages/ecpr-search.svelte'
import _faq from '../src/pages/faq.svelte'
import _forgotPassword from '../src/pages/forgot-password.svelte'
import _history from '../src/pages/history.svelte'
import _index from '../src/pages/index.svelte'
import _login from '../src/pages/login.svelte'
import _passwordReset from '../src/pages/password-reset.svelte'
import _passwordlessLogin from '../src/pages/passwordless-login.svelte'
import _pwc100Search from '../src/pages/pwc100-search.svelte'
import _updateSubscription from '../src/pages/update-subscription.svelte'
import _userInfoMenu from '../src/pages/user-info-menu.svelte'
import _wageReport from '../src/pages/wage-report.svelte'
import _webauthnOptions from '../src/pages/webauthn-options.svelte'

//options
export const options = {}

//tree
export const _tree = {
  "root": true,
  "children": [
    {
      "isPage": true,
      "path": "/change-password",
      "id": "_changePassword",
      "component": () => _changePassword
    },
    {
      "isPage": true,
      "path": "/dashboard",
      "id": "_dashboard",
      "component": () => _dashboard
    },
    {
      "isPage": true,
      "path": "/ecpr-search",
      "id": "_ecprSearch",
      "component": () => _ecprSearch
    },
    {
      "isPage": true,
      "path": "/faq",
      "id": "_faq",
      "component": () => _faq
    },
    {
      "isPage": true,
      "path": "/forgot-password",
      "id": "_forgotPassword",
      "component": () => _forgotPassword
    },
    {
      "isPage": true,
      "path": "/history",
      "id": "_history",
      "component": () => _history
    },
    {
      "isIndex": true,
      "isPage": true,
      "path": "/index",
      "id": "_index",
      "component": () => _index
    },
    {
      "isPage": true,
      "path": "/login",
      "id": "_login",
      "component": () => _login
    },
    {
      "isPage": true,
      "path": "/password-reset",
      "id": "_passwordReset",
      "component": () => _passwordReset
    },
    {
      "isPage": true,
      "path": "/passwordless-login",
      "id": "_passwordlessLogin",
      "component": () => _passwordlessLogin
    },
    {
      "isPage": true,
      "path": "/pwc100-search",
      "id": "_pwc100Search",
      "component": () => _pwc100Search
    },
    {
      "isPage": true,
      "path": "/update-subscription",
      "id": "_updateSubscription",
      "component": () => _updateSubscription
    },
    {
      "isPage": true,
      "path": "/user-info-menu",
      "id": "_userInfoMenu",
      "component": () => _userInfoMenu
    },
    {
      "isPage": true,
      "path": "/wage-report",
      "id": "_wageReport",
      "component": () => _wageReport
    },
    {
      "isPage": true,
      "path": "/webauthn-options",
      "id": "_webauthnOptions",
      "component": () => _webauthnOptions
    }
  ],
  "path": "/"
}


export const {tree, routes} = buildClientTree(_tree)

